export default "/images/arrow-left2.svg?9ae7c19ca219e8fc3049fa180605a4e5";